/**
 * App version displayed in the UI (issue #17).
 *
 * The value is baked into the bundle at build time: CI derives it from the
 * VERSION file (with a commit-SHA fallback while the pre-production baseline
 * is still 0.0.0) and passes it through Docker as the VITE_APP_VERSION
 * build-time env variable. A local `npm run dev`/`npm run build` without the
 * variable falls back to 0.0.0.
 */
export function resolveAppVersion(raw: string | undefined): string {
  const version = raw?.trim()
  return version ? version : '0.0.0'
}

export const APP_VERSION = resolveAppVersion(import.meta.env.VITE_APP_VERSION)
